import { nextTick } from 'vue'

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const { track } = useRecentPages()
  const error = useError()
  router.afterEach((to, _from, failure) => {
    if (failure || to.matched.length === 0) return
    /*
     * Errors thrown during page setup/data-fetching (e.g. createError()) surface
     * asynchronously via the global error state, after the router considers the
     * navigation successful — wait a tick so error.value has settled.
     */
    nextTick(() => {
      if (!error.value) track(to)
    })
  })
})
